// extracted by mini-css-extract-plugin
export default {"sider":"sider_sider__-vUpG","menu":"sider_menu__oahW9"};